<template>
  <div class="grafics-dashboard-wrapper">
    <Dashboard
      v-if="screens.length > 0"
      :token="token"
      :show-header="false"
      :lang="lang"
      :api-base-url="apiBaseUrl"
      :editable="false"
      :pdf-export="false"
      :screens="screens"
    />
  </div>
</template>

<script>
import Dashboard from '@vue-dashboard/views/Dashboard.vue'
import Configuration from '@/configuration'
import * as api from '@/utils/api'

export default {
  name: 'grafics-dashboard',
  components: { Dashboard },
  props: ['content', 'type', 'apiDefinitionId', 'id'],
  data () {
    return { screens: [], segmentName: '', loaded: false, _tokenTick: 0 }
  },
  computed: {
    token () {
      // eslint-disable-next-line no-unused-expressions
      this._tokenTick // dependència reactiva per forçar re-lectura del token
      return window.localStorage.getItem('user-token')
    },
    lang () {
      return this.$ml.current
    },
    apiBaseUrl () {
      return Configuration.value('API_SERVICES_URL')
    }
  },
  mounted () {
    this.$emit('definitionLoaded')
    if (!this.type || !this.type.endpoint) return
    api.call({
      access: api.ACCESS_SERVICES,
      url: this.type.endpoint,
      method: 'POST',
      data: { id: this.apiDefinitionId || this.id || 'home' }
    })
      .then(resp => {
        this.loaded = true
        if (resp && Array.isArray(resp.screens)) {
          this._tokenTick++ // força re-lectura del token fresc abans de muntar Dashboard
          this.screens = resp.screens
          if (resp.name) {
            this.segmentName = resp.name
            this.$emit('refreshDefinitionTitle', resp.name)
          }
        }
      })
      .catch(err => {
        console.error('grafics-dashboard: error carregant configuració', err)
      })
  }
}
</script>

<style scoped>
.grafics-dashboard-wrapper {
  overflow: auto;
  height: 100%;
  min-height: 600px;
}
.no-dashboard {
  padding: 40px;
  color: #666;
}
</style>
